import { render } from "./homeIndex2.vue?vue&type=template&id=58623339&scoped=true"
import script from "./homeIndex2.vue?vue&type=script&lang=js"
export * from "./homeIndex2.vue?vue&type=script&lang=js"

import "./homeIndex2.vue?vue&type=style&index=0&id=58623339&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/edu2-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58623339"]])

export default __exports__